import { ImmunizationPatient } from "../../models/Interfaces";
import React from "react";
import { useTranslation } from "react-i18next";
import "../../components/patientCard.css";
import ReportCard from "../../components/ReportCard";
import { getReportForState } from "../../utils/reportUtils";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "../../hooks";

interface ReportListProps {
  patient: ImmunizationPatient;
}

export default function ReportList() {
  const { state } = useLocation();
  const { patient } = (state as ReportListProps) || {};
  const { t } = useTranslation();
  const providerKey = patient.izProviderKey.toLowerCase();

  const njFeatures = useAppSelector((store) => store.immunizations.njFeatureFlag);
  // TODO: add report titles and func below to reportUtils.ts once getI18n() is working
  // TODO: Move this into the IzProvider
  const reportTitlesNJ = [
    t("immunizations.records_history_report_nj"),
    t("immunizations.records_immunization_report"),
  ];
  const reportTitlesWY = [t("immunizations.records_history_report_wy")];
  const reportTitlesWA = [t("immunizations.records_history_report_wa")];
  const reportTitlesID = [t("immunizations.records_history_report_id")];
  const reportTitlesAK = [t("immunizations.records_history_report_ak")];
  const reportTitlesMN = [t("immunizations.records_history_report")];
  const reportTitlesME = [t("immunizations.records_history_report")];
  const reportTitlesUT = [
    t("immunizations.records_school_report"),
    t("immunizations.records_forecast_report"),
    t("immunizations.records_personal_report"),
  ];
  const reportTitlesGeneric = [t("immunizations.records_history_report")];

  const getReportTitles = (providerKey: string) => {
    switch (providerKey) {
      case "wa":
        return reportTitlesWA;
      case "wy":
        return reportTitlesWY;
      case "ut":
        return reportTitlesUT;
      case "mn":
        return reportTitlesMN;
      case "me":
        return reportTitlesME;
      case "nj":
        return njFeatures ? reportTitlesNJ : reportTitlesNJ.slice(0, 1);
      case "id":
        return reportTitlesID;
      case "ak":
        return reportTitlesAK;
      default:
        return reportTitlesGeneric;
    }
  };

  return (
    <div className="section ml-1 mr-1 mt-1">
      <ul>
        {getReportTitles(providerKey).map((title, index) => (
          <li className="mb-4" key={index}>
            <ReportCard
              reportType={getReportForState(providerKey, index)}
              reportTitle={title}
              patient={patient}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
